import React from 'react';

export interface RawAgeDisplayerProps {
    age: number;
}

export const RawAgeDisplayer: React.FC<RawAgeDisplayerProps> = ({ age }) => <>{age}</>;
